import React                        from 'react';
import { qfnPlacements as tooltip } from 'pu-data/Tooltips';
import TextComponent                from './TextComponent';

const QfnPlacements = (props) => {
  const name = 'qfn';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="QFN<br />Placements"
      name={name}
      inputId={props.inputId}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={tooltip}
      groupName={props.groupName}
      inputClassName={props.inputClassName}
      errorMessage={props.errorMessage} />
  );
};

QfnPlacements.defaultProps = {
  inputId: 'qfn-placement',
};

export default QfnPlacements;
